import React, { FC } from "react";
import classNames from "classnames";
import { AnimationState } from "@app/hooks/use-slider/enums";
import { Slide } from "../../types";
import { MIN_SLIDES_TO_DISPLAY_NAVIGATION } from "./constants";
import { Slides } from "./components/slides/Slides";
import { Navigation } from "./components/navigation/Navigation";
import { Description } from "./components/description/Description";

type Props = {
  data: Slide[];
  activeSlide: number;
  animationState: AnimationState;
  onChangeSlide: (slideIndex: number) => void;
  onNextSlideSwitch: () => void;
  onPreviousSlideSwitch: () => void;
  onPause?: () => void;
  onStartPlay?: () => void;
};

export const Slider: FC<Props> = ({
  data,
  activeSlide,
  animationState,
  onChangeSlide,
  onNextSlideSwitch,
  onPreviousSlideSwitch,
  onPause,
  onStartPlay,
}) => {
  const onSlideSelect = (index: number) => onChangeSlide(index);

  return (
    <div
      className={classNames(
        "flex flex-col gap-y-7",
        "lg:gap-y-11",
        "xl:flex-row xl:items-stretch xl:justify-between",
      )}
    >
      <div
        className={classNames(
          "order-1 overflow-hidden",
          "xl:order-2 xl:w-[55%] xl:flex-initial",
        )}
      >
        <Slides
          {...{ data, activeSlide, onNextSlideSwitch, onPreviousSlideSwitch }}
        />
      </div>

      <div
        className={classNames(
          "order-2 space-y-6",
          "md:space-y-4",
          "xl:order-1 xl:w-[36%] xl:flex-initial xl:space-y-22",
        )}
      >
        {data.length >= MIN_SLIDES_TO_DISPLAY_NAVIGATION ? (
          <Navigation
            {...{
              data,
              activeSlide,
              animationState,
              onSlideSelect,
              onStartPlay,
              onPause,
            }}
          />
        ) : null}
        <div className="flex overflow-hidden">
          {data.map((slide, index) => (
            <div
              key={slide._uid}
              className={classNames("flex-0-100", {
                "order-first animate-fade-in": index === activeSlide,
              })}
            >
              <Description title={slide.title} text={slide.text} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
